module.exports = __webpack_public_path__ + "img/智能仓储系统.a37a0a65.png";